import {
    AfterViewInit,
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output,
} from "@angular/core";
import { IAuditorCoordenacaoModel } from "../../../../../app/models/auditor-coordenacao.model";
import { ICoordenacaoModel } from "../../../../../app/models/coordenacao.model";
import { IEnumModel } from "../../../../../app/models/enum.model";
import { ISubtipoAuditoriaModel } from "../../../../../app/models/subtipo-auditoria.model";
import { ITipoAuditoriaModel } from "../../../../../app/models/tipo-auditoria.model";
import { IUnidadeGestoraModel } from "../../../../../app/models/unidade-gestora.model";
import { AuthService } from "../../../../../app/services/auth.service";
import { CoordenacaoService } from "../../../../../app/services/coordenacao.service";
import { SubtipoAuditoriaService } from "../../../../../app/services/subtipo-auditoria.service";
import { TipoAuditoriaService } from "../../../../../app/services/tipo-auditoria.service";
import { UnidadeGestoraService } from "../../../../../app/services/unidade-gestora.service";
import { BaseListComponent } from "../../../../../app/shared/components/base-list/base-list.component";
import Swal from "sweetalert2";
import { ITipoEnfaseModel } from "../../../../../app/models/tipo-enfase.model";
import { FiltroModel } from "../../../../../app/models/filtro.model";
import { TipoEnfaseService } from "../../../../../app/services/tipo-enfase.service";
import { IOsaExecucaoFiltroModel, IOsaExecucaoModel } from "../../../../models/osa-execucao-model";
import { OsaExecucaoService } from "../../../../services/osa-execucao.service";

@Component({
  selector: 'app-osa-execucao-filtro',
  templateUrl: './osa-execucao-filtro.component.html',
  styleUrls: ['./osa-execucao-filtro.component.scss']
})
export class OsaExecucaoFiltroComponent
    extends BaseListComponent
    implements OnInit, AfterViewInit
{
    @Input() showButtonFilter: Boolean = true;
    @Input() situacaoSelecionada: number;
    public osaExecucaoModel: IOsaExecucaoModel = {} as IOsaExecucaoModel;
    private filtro: IOsaExecucaoFiltroModel = {} as IOsaExecucaoFiltroModel;
    public filtroModel: IOsaExecucaoFiltroModel = {} as IOsaExecucaoFiltroModel;
    public tipoEnfase: { resultado: ITipoEnfaseModel[] } = { resultado: [] };
    public coordenadores = [] as IAuditorCoordenacaoModel[];
    public unidadesGestoras = [] as IUnidadeGestoraModel[];
    public coordenacoes = [] as ICoordenacaoModel[];
    public subtiposAuditoria = [] as ISubtipoAuditoriaModel[];
    public tiposAuditoria = [] as ITipoAuditoriaModel[];

    public situacoes = [
        { codigo: 1, descricao: "Todos" },
        { codigo: 2, descricao: "Ativos" },
        {
            codigo: 3,
            descricao: "Inativos",
        },
    ] as IEnumModel[];

    public status = [
        { codigo: 1, descricao: "Em Elaboração" },
        { codigo: 2, descricao: "Em Aprovação" },
        { codigo: 3, descricao: "Homologada" },
        { codigo: 4, descricao: "Cancelada" }
    ];

    public origem = [
        { codigo: 1, descricao: "Planejada" },
        { codigo: 2, descricao: "Especial" },
    ];

    @Output() situacaoMudou = new EventEmitter<number>();

    constructor(
        public authService: AuthService,
        private osaExecucaoService: OsaExecucaoService,
        private unidadeGestoraService: UnidadeGestoraService,
        private coordenacaoService: CoordenacaoService,
        private subtipoAuditoriaService: SubtipoAuditoriaService,
        private tipoAuditoriaService: TipoAuditoriaService,
        public tipoEnfaseService: TipoEnfaseService,
    ) {
        super();
    }

    ngOnInit(): void {}

    ngAfterViewInit() {
        this.obterCoordenadores();
        this.obterUnidadesGestoras();
        this.obterCoordenacoes();
        this.carregaTipoEnfase();
        this.obterSubtiposAuditoria();
        this.obterTiposAuditoria();
    }

    public buscar() {
        this.osaExecucaoService.obter();
    }

    onSituacaoChange() {
        this.situacaoMudou.emit(this.situacaoSelecionada);
    }

    public obterCoordenadores() {
        this.coordenacaoService
            .obterCoordenadoresAtivos()
            .then((res) => {
                if (res.sucesso) {
                    this.coordenadores = res.dados;
                } else {
                    this.exibirMensagemErro(res.mensagem.descricao);
                }
            })
            .catch((err) => {
                this.exibirMensagemErro(err.mensagem.descricao);
            });
    }

    private obterSubtiposAuditoria() {
        this.subtipoAuditoriaService
            .obterAtivos()
            .then((res) => {
                this.subtiposAuditoria = res.dados;
            })
            .catch((err) => {
                this.exibirMensagemErro(err.mensagem.descricao);
            });
    }

    private obterTiposAuditoria() {
        this.tipoAuditoriaService
            .obterAtivos()
            .then((res) => {
                this.tiposAuditoria = res.dados;
            })
            .catch((err) => {
                this.exibirMensagemErro(err.mensagem.descricao);
            });
    }

    public obterCoordenacoes() {
        this.coordenacaoService
            .obter("", undefined, false)
            .then((res) => {
                if (res.sucesso) {
                    this.coordenacoes = res.dados;
                } else {
                    this.exibirMensagemErro(res.mensagem.descricao);
                }
            })
            .catch((err) => {
                this.exibirMensagemErro(err.mensagem.descricao);
            });
    }

    private obterUnidadesGestoras() {
        this.unidadeGestoraService
            .obterAtivos()
            .then((res) => {
                this.unidadesGestoras = res.dados;
            })
            .catch((err) => {
                this.exibirMensagemErro(err.mensagem.descricao);
            });
    }

  public async carregaTipoEnfase() {
    const filtro = {} as FiltroModel;
    this.tipoEnfaseService
      .obterTodos(filtro)
      .then((res) => {
        if (Array.isArray(res.dados.resultado)) {
          this.tipoEnfase = res.dados;
        } else {
          console.error(
            "O resultado não é um array:",
            res.dados.resultado
          );
          this.tipoEnfase = { resultado: [] };
        }
      })
      .catch((err) => {
        this.exibirMensagemAlerta(err.mensagem.descricao);
      });
  }

    buscarComFiltro() {
        this.filtro.numeroOsa = this.filtroModel.numeroOsa;
        this.filtro.numeroOpa = this.filtroModel.numeroOpa;
        this.filtro.unidadeGestoraId = this.filtroModel.unidadeGestoraId;
        this.filtro.origemAuditoria = this.filtroModel.origemAuditoria;
        this.filtro.tipoAuditoriaId = this.filtroModel.tipoAuditoriaId;
        this.filtro.dataInicioRealizacao = this.filtroModel.dataInicioRealizacao;
        this.filtro.dataFimRealizacao = this.filtroModel.dataFimRealizacao;
        this.filtro.dataElaboracao = this.filtroModel.dataElaboracao;
        this.filtro.coordenadorId = this.filtroModel.coordenadorId;
        this.filtro.tipoEnfaseId = this.filtroModel.tipoEnfaseId;
        this.filtro.subtipoAuditoriaId = this.filtroModel.subtipoAuditoriaId;
        this.filtro.auditorId = this.filtroModel.auditorId;
        this.filtro.status = this.filtroModel.status;
        this.filtro.coordenacao = this.filtroModel.coordenacao;
        this.filtro.ativo =
            this.situacaoSelecionada > 1
                ? this.situacaoSelecionada === 2
                : null;
        this.filtro.itensPorPagina = 50;

        // NOVO: Notificar o OsaListComponent sobre os filtros aplicados
        this.osaExecucaoService.notificarFiltrosAplicados(this.filtro);

        this.osaExecucaoService
            .obter(this.filtro)
            .then(() => {})
            .catch((error) => {
                Swal.fire({
                    toast: true,
                    position: "top-end",
                    icon: "error",
                    text: "Filtro não aplicado, ocorreu um erro!",
                    showConfirmButton: false,
                    timer: 5000,
                    timerProgressBar: true,
                });
            });
    }
}
